import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
// import { Button, InputText,  } from 'veloe-ds'

import {
  Heading,
  Paragraph,
  Content,
  Container,
  InputContainer,
  SearchInput,
  SearchButton,
  Wrapper,
  Timeline,
  Loading,
  Subtitle,
  WrapperTextoHeader,
  SearchIconContainer
} from './styles'
import { setLoading } from '../../modules/PageLoader/actions'
import ToggleSwitch from 'app/elements/ToggleSwitch'

import SearchIcon from '../../elements/Icons/SearchIcon'
import { helmetTitle, tag, papText, operacao } from './data.json'

import { gqlQuery, gqlMutate } from '../../../alelo-logic/services/common/apolloClient'
import {
  gqlHistoricoIdentificadorTag,
  gqlModificarPapIndividual
} from '../../../alelo-logic/services/queries/vehicles'

import imgTag from '../../../static/tag_veloe@2x.png'

import imgLoading from '../../../static/loading.gif'

class DashboardIdentifiersHistory extends Component {
  state = {
    identifier: null,
    pap: null,
    searchText: '',
    historico: null,
    loading: false,
    loadingPap: false,
    semRegistro: false,
    placa: null,
    tagInvalida: false
  }

  onUnload() {
    this.setState({ loadingPap: true })
  }

  componentDidMount() {
    this.props.setLoading(true)
    window.addEventListener('beforeunload', this.onUnload())
  }

  componentDidUpdate = prevProps => {
    const { accountPlans } = this.props
    if (prevProps.accountPlans.activePlanId && accountPlans && accountPlans.plans.length > 0) {
      setTimeout(() => this.props.setLoading(false), 400)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.onUnload())
  }

  handleSearchChange = ({ target }) => {
    // const { searchText } = this.state
    // if (searchText === '' || searchText.length < 10) {
    //   this.setState({ tagInvalida: true })
    // } else {
    //   this.setState({ tagInvalida: false })
    // }

    this.setState({ searchText: target.value })
  }

  handleSearchTag = async () => {
    this.setState({ loading: true, semRegistro: false })
    let returnData
    try {
      returnData = await gqlQuery(gqlHistoricoIdentificadorTag, {
        idConta: this.props.match.params.id,
        identificador: this.state.searchText
      })
    } catch (error) {
      returnData = {
        data: { historicoIdentificadorTag: { historicos: null, id: null, pap: null, placa: null } }
      }
      this.setState({
        semRegistro: true,
        historico: null,
        identifier: null,
        pap: null,
        placa: null
      })
    }

    const { data: { historicoIdentificadorTag: { historicos, id, pap, placa } } } = returnData

    if (historicos && this.state.semRegistro === false) {
      this.setState({ historico: historicos, pap, placa, identifier: id }, () =>
        this.setState({ loading: false })
      )
    } else {
      this.setState({
        loading: false,
        semRegistro: true,
        historico: null,
        identifier: null,
        pap: null,
        placa: null
      })
    }
  }

  convertDate = date => {
    const data = new Date(parseInt(date, 10))
      .toISOString()
      .substr(0, 10)
      .split('-')
      .reverse()
      .join('/')

    const hora = new Date(parseInt(date, 10)).toISOString().substr(11, 8)

    return `${data} ${hora}`
  }

  togglePap = async checked => {
    const { identifier, placa } = this.state
    // const changePap = checked ? 1 : 0
    this.setState({ pap: checked ? 1 : 0 })
    // changeTagIdentifiers(vehicle)

    try {
      await gqlMutate(gqlModificarPapIndividual, {
        idConta: this.props.match.params.id,
        adesaoPap: checked,
        identificador: identifier,
        placa: placa
      })
    } catch (error) {
      this.setState({ pap: !checked ? 1 : 0 })
      if (!this.state.loadingPap) alert('Problema ao executar pap')
      else this.setState({ loadingPap: false })
    }
  }

  render() {
    const { historico, loading, semRegistro, pap, identifier, tagInvalida, searchText } = this.state
    return (
      <section>
        <Helmet title={helmetTitle} />
        <Content>
          <Container style={{ display: 'flex', flexDirection: 'column' }}>
            <InputContainer>
              <SearchIconContainer>
                <SearchIcon />
              </SearchIconContainer>
              <SearchInput
                onChange={this.handleSearchChange}
                placeholder="Buscar pelo número da Tag"
              />
              <SearchButton onClick={this.handleSearchTag} disabled={searchText.length < 10}>
                Buscar
              </SearchButton>
            </InputContainer>
            {tagInvalida && (
              <div style={{ width: '100%', textAlign: 'center', marginTop: '20px' }}>
                <Subtitle>TAG inválido</Subtitle>
              </div>
            )}
          </Container>
          {loading && (
            <div style={{ width: '100%', textAlign: 'center' }}>
              <Loading src={imgLoading} />
            </div>
          )}
          {semRegistro && (
            <div style={{ width: '100%', textAlign: 'center' }}>
              <Subtitle>Número de TAG inválido</Subtitle>
            </div>
          )}
          {historico &&
            !loading && (
              <div>
                <Wrapper>
                  <WrapperTextoHeader>
                    <Paragraph>{tag}</Paragraph>
                    <Heading>{identifier}</Heading>
                    <Paragraph style={{ display: 'flex' }}>
                      <span style={{ marginRight: '10px' }}>{papText}</span>
                      <ToggleSwitch
                        checked={pap === 1}
                        label={pap === 1 ? 'Ativo' : 'Inativo'}
                        name="pap"
                        togglePap={this.togglePap}
                      />
                    </Paragraph>
                  </WrapperTextoHeader>
                  <div>
                    <img src={imgTag} alt="" style={{ width: '240px' }} />
                  </div>
                </Wrapper>

                <Timeline>
                  <div className="history-tl-container">
                    <ul className="tl">
                      {historico.map((item, index) => (
                        <li key={index} className="tl-item">
                          <span>{index + 1}</span>
                          <div className="item-title">{operacao[item.operacao]}</div>
                          <div className="item-detail">{this.convertDate(item.dataInclusao)}</div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Timeline>
              </div>
            )}
        </Content>
      </section>
    )
  }
}

const mapStateToProps = ({ reducer }) => ({
  accountPlans: reducer.accountPlans
})

const mapDispatchToProps = dispatch => ({
  dispatch,
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardIdentifiersHistory)



// WEBPACK FOOTER //
// ./src/app/pages/DashboardIdentifiersHistory/index.js